import BaseClient from '@/app/model/api/response/baseApiClient'

class NewsBoardDeleteApi extends BaseClient {
  public doNewsBoardDelete (id: string) {
    const path: string = '/v1/news-boards/' + id

    /* 共通処理 */
    return super.doFetch(process.env.VUE_APP_API_URL + path, 'DELETE')
  }
}

export default new NewsBoardDeleteApi()
